<template>
  <div class="layout-footer">
    <div class="w-full pt-4" style="background-color: #f5f6f7">
      <div class="w-full max-w-screen-xl m-auto">
        <!-- 友链,联系方式 -->
        <div class="table overflow-hidden text-gray-400">
          <div
            class="table-cell overflow-hidden align-middle"
            style="width: calc(100% - 200px)"
          >
            <div class="overflow-hidden">
              <span
                v-for="(item, index) in friendLink"
                :key="index"
                class="float-left pr-4"
              >
                <a class="text-gray-400" :href="item.url">{{ item.name }}</a>
              </span>
            </div>
          </div>
          <!-- <div class="table-cell text-center" style="width: 200px">
            <img :src="$ossUrl + setting.miniapp_qrcode" class="w-32 m-auto" />
            <a :href="`tel:${setting.tel}`">
              <div class="mt-4 text-xs text-black">
                联系方式: {{ setting.tel }}
              </div>
            </a>
          </div> -->
        </div>
        <!-- 其他 -->
        <div class="text-center">
          <span class="mr-4 text-xs leading-9" style="color: #646a73">
            Copyright © 2021 {{ setting.company_name }}
          </span>
          <span class="mr-4 text-xs leading-9" style="color: #646a73">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              style="color: #646a73"
            >
              {{ setting.icp }}
            </a>
          </span>

          <span class="text-xs leading-9" style="color: #646a73">
            <a
              target="_blank"
              class="text-white"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33100202001322"
            >
              <img src="@/assets/images/gongan.png" class="inline mr-1" />
              <span style="color: #646a73">
                {{ setting.gov_record }}
              </span>
            </a>
            <span class="pl-4 text-xs" style="color: #646a73">
              技术支持:浙江金电保数字科技有限公司
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '@/api/config';
import { friend_links } from '@/api/friend_link';
export default {
  name: 'Footer',
  components: {},
  data() {
    return { setting: {}, friendLink: [] };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getConfig();
    this.getFriendLinks();
  },
  methods: {
    async getConfig() {
      this.setting = (await config()) || {};
    },
    async getFriendLinks() {
      this.friendLink =
        (
          await friend_links({
            orderby: 'sort desc',
            current: -1,
          })
        ).data || [];
    },
  },
};
</script>

<style lang="less" scoped>
.headershadow {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.06);
}
</style>
